<template>
  <button
    class="cell-break"
    type="button"
    v-bind:class="{ 'cell-break--single-row': isOneRowLayout }"
    v-bind:title="title"
    v-on:click="onClick"
  >
    <template v-if="isOneRowLayout">
      <div class="cell-break__row">
        Перерыв
        <span class="cell-break__time cell-break__time--row">{{ interval }}</span>
      </div>
    </template>
    <template v-else-if="isDefaultLayout">
      <span class="cell-break__name">{{ breakTitle }}</span>
      <span class="cell-break__time">{{ interval }}</span>
    </template>
  </button>
</template>

<script>

/**
 * @description Название события открытия.
 * @type {string}
 */
const NAME_EVENT_OPEN = 'open';

/**
 * @description Компонент слота перерыва.
 * @type {Vue}
 */
export default {
  computed: {
    isOneRowLayout() {
      return this.tags.includes('one-row-layout');
    },
    isDefaultLayout() {
      return this.tags.includes('only-color-layout') === false;
    },
    breakTitle() {
      const text = 'Перерыв';
      return this.note ? `${text}: ${this.note}` : text;
    },
  },
  methods: {
    /**
     * @description Обработать нажатие.
     * @returns {void}
     */
    onClick() {
      this.$emit(NAME_EVENT_OPEN);
    },
  },
  name: 'TimetableBreakCell',
  props: {
    interval: { required: true, type: String },
    note: { default: '', type: String },
    tags: { required: true, type: Array },
    title: { required: true, type: String },
  },
};
</script>

<style scoped lang="scss">
.cell-break {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 8px 14px;
  background-color: var(--unfocus-color);
  height: 100%;
  width: 100%;
  &--single-row {
    padding-block: 0;
  }
  &__row {
    width: 100%;
    font-size: 12px;
    white-space: nowrap;
    color: #192a3e;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &__name {
    text-align: left;
    font-weight: 400;
    font-size: 10px;
    color: #192a3e;
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }
  &__time {
    color: #192a3e;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    margin: 4px 0 0 0;
    &--row {
      font-size: inherit;
      white-space: nowrap;
    }
  }
}
</style>
